import VueRouter from 'vue-router'
import { RawLocation, Location, Route } from 'vue-router/types/router'
import CoreStoreModule from '../vuex/CoreStoreModule'

export default class OrganizationNavigator {
  router: VueRouter
  coreStoreModule: CoreStoreModule
  defaultRouteName: string
  baseUrl: string

  constructor (router: VueRouter, coreStoreModule: CoreStoreModule, defaultRouteName: string, baseUrl: string) {
    this.router = router
    this.coreStoreModule = coreStoreModule
    this.defaultRouteName = defaultRouteName
    this.baseUrl = baseUrl
  }

  push (location: RawLocation): Promise<Route> {
    if (typeof location !== 'string') {
      if ((location as Location).params === undefined) {
        (location as Location).params = {}
      }
      (location as Location).params!.organizationId = this.coreStoreModule.activeUserOrganization!.id
    }
    return this.router.push(location)
  }

  changeOrganization (organizationId: string): Promise<Route> {
    const orgKey = `${this.baseUrl}revasos`
    if (organizationId === '-') {
      const organizations = this.coreStoreModule.userOrganizations
      if (organizations === null) {
        throw new Error('Navigator.changeOrganization: CoreStoreModule not initialized with user organizations')
      }
      if (organizations.length === 0) {
        throw new Error('Navigator.changeOrganization: user has no organizations')
      }
      if (organizations.length > 0) {
        const found = window.localStorage.getItem(orgKey)
        if (found === null) {
          organizationId = organizations[0].id
          window.localStorage.setItem(orgKey, organizationId)
        } else {
          const isUserStillCollaborator = organizations.find((o) => found === o.id)
          if (isUserStillCollaborator === undefined) {
            window.localStorage.removeItem(orgKey)
            window.localStorage.setItem(orgKey, organizations[0].id)
            organizationId = organizations[0].id
          } else {
            organizationId = found
          }
        }
      }
    } else {
      window.localStorage.setItem(orgKey, organizationId)
    }

    const location: Location = {
      name: this.defaultRouteName,
      params: {
        organizationId
      }
    }
    const r = this.router.push(location)
    this.router.go(0)
    return r
  }
}
